import React, { FC, useState } from "react"
import { FieldValues, SubmitHandler, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { FormInput, UButton, UText, FormSelect } from "../../../components"
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Divider,
} from "../../../components/mui.components"
import { setAlert } from "../../../core/app/slices/alert/alertSlice"
import { IUpdatePassword } from "../../../core/app/slices/user/user.service"
import { updatePassword } from "../../../core/app/slices/user/userApis"
import PasswordIcon from "../../Auth/Login/PasswordIcon"
import { validations } from "@/core/utils/validations"
import * as lodash from "lodash"
import { loginAlliedStar } from "@/core/global/httpAlliedstar"
const TypeOptions = [
  { key: "3Shape", value: "3Shape" },
  // { key: "Medit", value: "Medit" },
  { key: "Alliedstar", value: "Alliedstar" },
]

const { VITE_DOMAIN } = import.meta.env
const AddScanner = ({ scannerData, setScannerData }) => {
  const {
    control,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm<{ type: string }>({ mode: "onSubmit" })
  const [visibilePassword, setVisibilePassword] = useState<boolean>(false)
  const onSubmit: SubmitHandler<{ type: string }> = async (data) => {
    const tmp = scannerData.filter((i) => i.name === data.type)
    if (data.type === "3Shape" && tmp.length === 0) {
      const url = `https://identity.3shape.com/connect/authorize?client_id=UlUTXMHM7GGRTVb&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=${VITE_DOMAIN}/settings/integrations&code_challenge=mwofHihL4F89LWgqhai-9GTAAhJtTIvR5bOqz_3_B9E&code_challenge_method=S256&response_mode=query`
      window.location.href = url
    }
    if (data.type === "Alliedstar" && tmp.length === 0) {
      loginAlliedStar(`${VITE_DOMAIN}/settings/integrations`)
      // loginAlliedStar(`http://localhost:3000/settings/integrations`)
    }

    if (data.type === "Medit" && tmp.length === 0) {
      const url = `https://stage-openapi-auth.meditlink.com/oauth/authorize?client_id=PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo&response_type=code&redirect_uri=${VITE_DOMAIN}/settings/integrations?from=medit&scope=USER%20GROUP%20CASE%20FILE%20ORDER%20PRODUCT:DENTAL%20FILE:MANAGE%20ORDER:MANAGE&state=bn6q6ru91ygkzwo8rfc0s1f7`
      const localurl = `https://stage-openapi-developers.meditlink.com/oauth/authorize?client_id=PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo&response_type=code&redirect_uri=http://localhost:3000/settings/integrations?from=medit&scope=USER%20GROUP%20CASE%20FILE%20ORDER%20PRODUCT:DENTAL%20FILE:MANAGE%20ORDER:MANAGE&state=bn6q6ru91ygkzwo8rfc0s1f7`
      window.location.href = url
    }
  }
  return (
    <Box component={"form"} onSubmit={handleSubmit(onSubmit)}>
      <UText
        variant={"subtitle1"}
        sxProp={{ color: "rgba(0,0,0,0.6)" }}
      >{`Select your scanner`}</UText>
      {/* <FormInput
        inputLabel={"formfields.email"}
        fieldName={"username"}
        rules={{
          required: "formfieldErrors.emailrequired",
          pattern: {
            value: validations.email.pattern.value,
            message: "formfieldErrors.userEmailinvalid",
          },
        }}
        errors={errors}
        control={control}
      />
      <FormInput
        inputLabel={"formfields.password"}
        fieldName={"password"}
        fieldType={visibilePassword ? "text" : "password"}
        rules={{ required: "formfieldErrors.passwordrequired" }}
        errors={errors}
        control={control}
        endAdornmentIcon={
          <PasswordIcon
            updatePasswordVisible={setVisibilePassword}
            isError={!!(errors && errors.password)}
          />
        }
        autoComplete="new-password"
      /> */}
      <FormSelect
        inputLabel="Brand"
        fieldName="type"
        rules={{ required: "settings.Integrations.scannerTypeError" }}
        errors={errors}
        control={control}
        options={TypeOptions}
      ></FormSelect>
      <UButton
        sxProp={{ mt: 3, width: "100%" }}
        variant={"contained"}
        btnType={"submit"}
        btnText={`Connect`}
      />
      {scannerData.length > 0 && <Divider sx={{ my: 4 }} />}
    </Box>
  )
}
export default AddScanner
